import { statusText } from "./shipmentStatus";
import type { TowerGeoAlert } from "../../../types/controlTower";
import { searchKey } from "./towerFormat";

// Alertas geográficas: qué se lista, búsqueda y agrupado por chofer.

// Solo se listan alertas comparables (principal o leve); las de ubicación
// dudosa o sin coordenadas no son errores de despacho y no se muestran.
export function isListedAlert(alert: TowerGeoAlert): boolean {
  return alert.severity === "main" || alert.severity === "light";
}

export function filterGeoAlerts(items: TowerGeoAlert[], query: string): TowerGeoAlert[] {
  const q = searchKey(query.trim());
  return items.filter((alert) => {
    if (!isListedAlert(alert)) return false;
    const s = alert.shipment;
    return !q || searchKey(`${alert.driverName} ${s.client} ${s.locality} ${s.tracking} ${s.address}`).includes(q);
  });
}

// Agrupa por chofer conservando el orden de prioridad que ya trae el backend.
export function groupByDriver(
  items: TowerGeoAlert[],
): { driverId: string; driverName: string; alerts: TowerGeoAlert[] }[] {
  const groups = new Map<string, { driverId: string; driverName: string; alerts: TowerGeoAlert[] }>();
  for (const alert of items) {
    if (!groups.has(alert.driverId))
      groups.set(alert.driverId, { driverId: alert.driverId, driverName: alert.driverName, alerts: [] });
    groups.get(alert.driverId)!.alerts.push(alert);
  }
  return [...groups.values()];
}

// Estado tal como está en el sistema; si ya se entregó, con la hora.
export function geoStatusText(alert: TowerGeoAlert): string {
  const s = alert.shipment;
  const time = s.stateDate?.slice(11);
  return s.status === "delivered" && time ? `${statusText(s)} ${time}` : statusText(s);
}

export function mapsUrl(alert: TowerGeoAlert): string {
  const s = alert.shipment;
  const query =
    s.latitude !== null && s.longitude !== null
      ? `${s.latitude},${s.longitude}`
      : [s.address, s.locality].filter(Boolean).join(", ");
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
}
